import { useState, useEffect } from 'react';
import axios from 'axios';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import './Indian.scss';
import CalenderLinks from '../../../components/CalanderLinks/CalanderLinks';
import HinduEventDescriptions from '../../../../middleware/hinduEventDescriptions';

const Indian = () => {
  const [expandedMonths, setExpandedMonths] = useState({});
  const [allMonths, setAllMonths] = useState([]);
  const [selectedFestival, setSelectedFestival] = useState(null);

  const handleFestivalClick = (festival) => {
    setSelectedFestival(festival);
  };

  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [tempYear, setTempYear] = useState(currentYear);

  // ================== API FETCH ==================
  useEffect(() => {
    const fetchFestivals = async () => {
      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/hindu-festival?year=${year}`
        );

        const festivalsData = res.data?.months || {};

        const formattedData = Object.entries(festivalsData).map(
          ([month, festivals]) => ({
            month: `${month}, ${year}`,
            festivals: festivals.map(f => ({
              name: f.name,
              date: new Date(f.date).toDateString(),
              calendar: f.calendar,
            })),
          })
        );

        setAllMonths(formattedData);
      } catch (error) {
        console.error('Failed to fetch Indian festival data:', error);
      }
    };

    fetchFestivals();
  }, [year]);

  // ================== BROWSER BACK SUPPORT ==================
  useEffect(() => {
    const handleBackButton = () => {
      setSelectedFestival(null);
    };

    if (selectedFestival) {
      window.history.pushState({}, '');
      window.addEventListener('popstate', handleBackButton);
    }

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [selectedFestival]);

  const handleToggle = (index) => {
    setExpandedMonths(prev => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleSubmit = () => {
    setYear(tempYear);
  };

  // ================== DETAIL PAGE ==================
  if (selectedFestival) {
    const description =
      HinduEventDescriptions[selectedFestival.name] ||
      'Description not available.';

    return (
      <div className="Indian-container">
        <InnerNav />

        <div className="Indian-content">
          <button
            className="back-btn"
            onClick={() => setSelectedFestival(null)}
          >
            ← Back
          </button>

          <h1>{selectedFestival.name}</h1>
          <p><strong>Date:</strong> {selectedFestival.date}</p>
          <p><strong>Calendar:</strong> {selectedFestival.calendar}</p>

          <p style={{ whiteSpace: 'pre-line', marginTop: '20px' }}>
            {description}
          </p>
        </div>

        <Footer />
      </div>
    );
  }

  // ================== LIST PAGE ==================
  return (
    <div className="Indian-container">
      <InnerNav />
      <div className="Indian-content">

        <div className="year-selector">
          <label htmlFor="year">Select Year: </label>
          <input
            id="year"
            type="number"
            min="1900"
            max="2100"
            value={tempYear}
            onChange={(e) => setTempYear(Number(e.target.value))}
          />
          <button className="submit" onClick={handleSubmit}>Submit</button>
        </div>

        <h1>Indian Festivals</h1>

        {allMonths.map((month, index) => {
          const isExpanded = expandedMonths[index];
          const visibleFestivals = isExpanded
            ? month.festivals
            : month.festivals.slice(0, 2);

          return (
            <div className="monthFestivals" key={index}>
              <h2>{month.month}</h2>

              <div className="list-Of-festivals">
                {visibleFestivals.map((fest, i) => (
                  <div
                    key={i}
                    className="festival-tile"
                    onClick={() => handleFestivalClick(fest)}
                  >
                    <div className="image">
                      <img
                        src="https://static.virtubox.io/project/file/20210317-174419-ikhm-jya670.jpg"
                        alt="Festival Icon"
                      />
                    </div>
                    <div className="info">
                      <p>{fest.name}</p>
                      <p>{fest.date}</p>
                    </div>
                  </div>
                ))}
              </div>

              {month.festivals.length > 2 && (
                <button onClick={() => handleToggle(index)}>
                  {isExpanded ? 'Show less' : 'More festivals'}
                </button>
              )}
            </div>
          );
        })}

        <CalenderLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Indian;
